import moment from "moment";
import "moment/min/locales";

import { CUSTOM_DATE_FORMATS } from "../constants/customDateFormats";

// Function to return all months in short capital letters for a given language
export const getAllMonths = (language = "en") => {
  // Set Moment.js locale based on the language parameter
  moment.locale(language);

  // Get the array of month abbreviations for the specified language
  const monthAbbreviations = moment.monthsShort();

  // Map the abbreviations to uppercase and return
  return monthAbbreviations.map(month => month.toUpperCase());
};

export const getYearAndQuarter = (date, language = "en") => {
  return `Q${moment(date).quarter()} ${moment(date).year()}`;
};

export const getYearAndPreviousQuarter = (date, language = "en") => {
  let prevQuarter = moment(date).subtract(1,"quarter");
  return `Q${moment(prevQuarter).quarter()} ${moment(prevQuarter).year()}`;
};

export const getLongDate = (date, language = "en") => {
  return moment(date,moment.ISO_8601, language).format(CUSTOM_DATE_FORMATS.LongDateWithShortMonth);
};

export const getShortDate = (date, language = "en") => {
  return moment(date,moment.ISO_8601, language).format(CUSTOM_DATE_FORMATS.ShortMonthShortYear);
};

export const getMonthDayYearDate = (date, language = "en") => {
  return moment(date, moment.ISO_8601, language).format(CUSTOM_DATE_FORMATS.MonthDayYear);
};

export const getShortMonthLongYearDate = (date, language = "en") => {
  return moment(date,moment.ISO_8601, language).format(CUSTOM_DATE_FORMATS.ShortMonthLongYear);
};

export const getYearMonthDay = (date, language = "en") => {
  return moment(date,moment.ISO_8601, language).format(CUSTOM_DATE_FORMATS.YearMonthDay);
};

export const getLongMonthLongYearDate = (date, language = "en") => {
  return moment(date,moment.ISO_8601, language).format(CUSTOM_DATE_FORMATS.LongMonthLongYear);
};

export const getUtcDateTime = (dateTime) => {
  return moment.utc(dateTime).format("YYYY-MM-DDTHH:mm:ss");
};